module.exports = {"name":"NED-0534-got-show-matcher","working":["dna-cinemaguide","dna-demo-expanding-grid","dna-news-map","dna-news-map-editor","demo-simple-chart","NED-0534-got-show-matcher"],"moved_to_live":["NED-0380-operation-wait-times","dna-sa-election-policy-dashboard","NED-0154-election-sa-policy-picker-quiz","NED-0285-nsw-suburb-crime-stats-phase1"]}


//////////////////
// WEBPACK FOOTER
// ./src/content/project.json
// module id = peJn
// module chunks = 0